<template>
  <div>
    <div class="list-title"> {{ title }} </div>
    <div class="list-content">
        <collocation v-for="s in lemposList" :key="s" :lempos-string="s"
                :pattern="pattern" :core-indexes="coreIndexes" :show-core="false" class="collocation"/>
    </div>
  </div>
</template>

<script>
import Collocation from './Collocation.vue'

export default {
  name: 'CollocationList',
  props: {
    lemposList: Array,
    title: String,
    coreIndexes: Array,
    pattern: String
  },
  computed: {
  },
  components: {
    Collocation
  }
}
</script>

<style scoped>
</style>
